/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// // モーダルを制御するためのJavaScript
window.addEventListener('load', function() {
  function adjustDivHeight() {
    // PC画像とSP画像の両方を取得
    const pcImage = document.getElementById('imagePcOn');
    const spImage = document.getElementById('imageSpOn');
    const product_media_container = document.getElementById('product_media_container');

    // ライト点灯の画像は、スイッチを使うテンプレートでしか描かれない。
    // zakka など一般的な画像表示のテンプレートでは要素が無いので何もしない。
    if (!product_media_container || !pcImage || !spImage) {
      return;
    }

    // 表示されている画像の高さを取得してdivの高さを調整
    if (window.innerWidth > 768) {
      // PC画面の場合、PC画像の高さを適用
      product_media_container.style.height = pcImage.clientHeight + 'px';
    } else {
      // SP画面の場合、SP画像の高さを適用
      product_media_container.style.height = spImage.clientHeight + 'px';
    }
  }

  // ページロード時に画像の高さを適用
  window.addEventListener('load', function () {
    adjustDivHeight();
  });
});

window.addEventListener('load', function () {
  // classにjs-hideが指定されている要素全てを取得し、表示する
  const hide_items = document.querySelectorAll(".js-hide");
  if (hide_items !== null) {
    hide_items.forEach(hide_item => {
      hide_item.classList.toggle("js-hide");
      hide_item.classList.toggle("js-show");
    });
  }
});

// ページロード時に画像の高さを適用
window.addEventListener('load', function () {
  showSection();
});

// // モーダルを制御するためのJavaScript
var product_image_modal = document.getElementById("imageModal");
var product_media_modal_openBtn = document.getElementById("imageModalopen");
var product_media_modal_closeBtn = document.querySelector(".product_media_modal_close");

// このモーダルは custom-product-media（ライトのスイッチを使う表示）にしかない。
// テーマ本来の画像表示を使うテンプレートでは要素が無いので、以降を実行しない。
// ここで例外が出ると、これより下のサムネイル処理まで巻き添えで止まる。
if (product_image_modal && product_media_modal_openBtn && product_media_modal_closeBtn) {
  product_media_modal_openBtn.addEventListener('click', function () {
    product_image_modal.style.display = "block"; // モーダルを表示
    setTimeout(() => {
      product_image_modal.classList.add('show'); // ふわっと表示するクラスを追加
    }, 10); // 少し遅らせてクラスを追加することでトランジションを発動させる
  });

  // モーダルを閉じる
  product_media_modal_closeBtn.onclick = function () {
    product_image_modal.classList.remove('show'); // モーダルを非表示にするクラスを削除
    setTimeout(() => {
      product_image_modal.style.display = "none"; // クラスが削除された後に非表示
    }, 500); // アニメーション時間と一致させる
  }

  // モーダル外をクリックして閉じる
  window.onclick = function (event) {
    if (event.target == product_image_modal) {
      product_image_modal.classList.remove('show'); // モーダルを非表示にするクラスを削除
      setTimeout(() => {
        product_image_modal.style.display = "none"; // クラスが削除された後に非表示
      }, 500); // アニメーション時間と一致させる
    }
  }
}

// サムネイルクリックで画像をスクロールして表示
document.querySelectorAll('.thumbnail').forEach((thumbnail, index) => {
  thumbnail.addEventListener('click', function () {
    // サムネイルの img も .modal-content の中にあるので、
    // スライド側だけを対象にする。
    const images = document.querySelectorAll('.modal-wrapper .modal-slide img');
    const targetImage = images[index];
    if (!targetImage) return;

    // スクロール位置を正確に計算
    const modalRect = product_image_modal.getBoundingClientRect();
    const targetRect = targetImage.getBoundingClientRect();

    // 画像が画面の中央にくる位置までスクロールする。
    const imageTop = targetRect.top - modalRect.top + product_image_modal.scrollTop;
    const centerOffset = (product_image_modal.clientHeight - targetRect.height) / 2;
    const maxOffset = product_image_modal.scrollHeight - product_image_modal.clientHeight;
    const offset = Math.max(0, Math.min(imageTop - centerOffset, maxOffset));

    // スクロールを実行
    setTimeout(() => {
      product_image_modal.scrollTo({
        top: offset, // 画像の位置にスクロール
        behavior: 'smooth' // スムーズなスクロール
      });
    }, 10); // 少し遅らせてスクロールを実行
  });
});

// スマホ用の商品画像スライダー（ライトのスイッチを出さないページ）
// 横スクロール＋スクロールスナップで動くので、矢印とドットの見た目を合わせるだけ。
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('[data-product-media-slider]');

  // スライダーはスイッチを出さないページにしか無い
  if (!slider) {
    return;
  }

  const slides = slider.querySelector('[data-product-media-slides]');
  const prevButton = slider.querySelector('[data-product-media-prev]');
  const nextButton = slider.querySelector('[data-product-media-next]');
  const dots = Array.from(slider.querySelectorAll('[data-product-media-dot]'));

  if (!slides) {
    return;
  }

  // 画像が1枚のときは矢印もドットも出していない
  if (!prevButton || !nextButton) {
    return;
  }

  function currentIndex() {
    const slideWidth = slides.clientWidth;

    if (slideWidth === 0) {
      return 0;
    }

    return Math.round(slides.scrollLeft / slideWidth);
  }

  function scrollToIndex(index) {
    slides.scrollTo({ left: slides.clientWidth * index, behavior: 'smooth' });
  }

  function updateControls() {
    const index = currentIndex();

    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });

    prevButton.disabled = index <= 0;
    nextButton.disabled = index >= dots.length - 1;
  }

  prevButton.addEventListener('click', function () {
    scrollToIndex(currentIndex() - 1);
  });

  nextButton.addEventListener('click', function () {
    scrollToIndex(currentIndex() + 1);
  });

  dots.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      scrollToIndex(index);
    });
  });

  // スワイプで動かしたときもドットを合わせる。
  // スクロール中に何度も呼ばれるので、止まったときだけ処理する。
  let scrollTimer = null;

  slides.addEventListener('scroll', function () {
    if (scrollTimer) {
      clearTimeout(scrollTimer);
    }

    scrollTimer = setTimeout(updateControls, 100);
  });

  updateControls();
});

// ON/OFFボタンで画像を切り替える
document.addEventListener('DOMContentLoaded', function () {
  const pcOnImage = document.getElementById('imagePcOn');
  const pcOffImage = document.getElementById('imagePcOff');
  const spOnImage = document.getElementById('imageSpOn');
  const spOffImage = document.getElementById('imageSpOff');
  const onButton = document.getElementById('onButton');
  const offButton = document.getElementById('offButton');

  // ライト点灯スイッチは、ON/OFF画像を持つ対象商品でのみ描画される。
  // 対象外の商品ページや商品以外のページでは要素が存在しないため、何もせず抜ける。
  if (!pcOnImage || !pcOffImage || !spOnImage || !spOffImage || !onButton || !offButton) {
    return;
  }

  // 初期状態はOFF画像を表示
  updateImages('on');

  // ONボタンをクリックしたときの処理
  onButton.addEventListener('click', function () {
    updateImages('on');
    onButton.classList.add('active');
    offButton.classList.remove('active');
  });

  // OFFボタンをクリックしたときの処理
  offButton.addEventListener('click', function () {
    updateImages('off');
    offButton.classList.add('active');
    onButton.classList.remove('active');
  });

  // 画面サイズに応じてPC用かSP用の画像を切り替える
  function updateImages(state) {
    const isMobile = window.innerWidth <= 768; // 768px以下はスマホ画面

    // まず全ての画像を非表示
    pcOnImage.classList.remove('active');
    pcOffImage.classList.remove('active');
    spOnImage.classList.remove('active');
    spOffImage.classList.remove('active');

    // 状態に応じて、表示する画像にactiveクラスを追加
    if (state === 'on') {
      if (isMobile) {
        spOnImage.classList.add('active');
      } else {
        pcOnImage.classList.add('active');
      }
    } else {
      if (isMobile) {
        spOffImage.classList.add('active');
      } else {
        pcOffImage.classList.add('active');
      }
    }
  }

  // ウィンドウサイズが変更されたときに画像を再更新
  window.addEventListener('resize', function () {
    const currentState = onButton.classList.contains('active') ? 'on' : 'off';
    updateImages(currentState);
  });
});
